import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { ToastStack, ToastStackProvider } from '@/components/feedback/toast-stack'
import { TooltipProvider } from '@/components/ui/tooltip'
import { applyThemeClass, useThemeStore } from '@/stores/theme-store'

/**
 * TanStack Query varsayılanları (görev dosyası): 30 sn `staleTime`, tek yeniden
 * deneme, pencere odağında yeniden istek yok — SSE zaten tazeliyor.
 */
function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })
}

function ThemeEffect() {
  const theme = useThemeStore((state) => state.theme)

  useEffect(() => {
    applyThemeClass(theme)
    if (theme !== 'system') return
    const media = window.matchMedia('(prefers-color-scheme: dark)')
    const listener = () => applyThemeClass(theme)
    media.addEventListener('change', listener)
    return () => media.removeEventListener('change', listener)
  }, [theme])

  return null
}

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeEffect />
        <TooltipProvider>
          <ToastStackProvider>
            {children}
            <ToastStack />
          </ToastStackProvider>
        </TooltipProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
